import { Toast } from 'interfaces/Toast';
import { eventBus } from 'utils/eventbus';

type FocusTarges = 'chatInput' | 'lastMessage' | 'backButton';

export type WidgetEventChannel = typeof widgetEventChannel;

export const widgetEventChannel = eventBus<{
    toast: (payload: Toast) => void;
    stopVoiceRecording: () => void;
    showInputWidgetElementErrors: () => void;
    focusTo: (target: FocusTarges) => void;
    toggleMobileOverride: (payload: boolean) => void;
    toggleShowLoaderOverride: (payload: boolean) => void;
    forceUpdateSearchParamsDependency: () => void;
    toggleTimeAndStatusOpacity: () => void;
    uitest__mutateSelectionAwareTextAreaValue: (pageNumber: string) => void;
    uitest__updated_inputJson: (args: {
        inputJson: string;
        setInputJson: (inputJson: string) => void;
    }) => void;
    uitest__request_inputJson: () => void;
    setScrollHandlers: (handlers: string[] | undefined) => void;
    desktop__toggle_is_isolated_bubble: (payload: { msgId: string }) => void;
    ctxMenuClosed: () => void;
}>();
